// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3Tl0q","colMaxWidth":"Table_colMaxWidth__3E1Ex"};